export const isSelectingCustomer = state => state.ui.isSelectingCustomer;



// WEBPACK FOOTER //
// ./src/store/ui/selectors.js